import Vue from 'vue';
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js';
import formGreen from '@components/base/form-green.vue';
import { mapState } from "vuex";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            // error: false,
            dataSlider: [],
            rotateIndex: -1,
            activeFact: '1',
            scrollTags: 0,
            max: 0,
            aboutTimeline: {
                slidesPerView: 'auto',
                spaceBetween: 32,
                cursor: "grab",
                navigation: {
                    nextEl: '.js-timeline-next',
                    prevEl: '.js-timeline-prev',
                }
            },
            reviewsOption: {
                spaceBetween: 32,
                loop: true,
                cursor: "grab",
                pagination: {
                    el: ".js-reviews-pag",
                    clickable: true
                }
            },
            achievementsOption: {
                spaceBetween: 32,
                loop: true,
                cursor: "grab",
                pagination: {
                    el: ".js-achievements-pag",
                    clickable: true
                }
            }
        }
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    components: {
        'banner-btn-cmp': BannerBtn,
        'form-green-cmp': formGreen,
    },
    methods: {
        // errorData(data) {
        //     this.error = data.error;
        // },
        aboutSlideTo(index) {
            // если кликаем не на активный слайд
            if (!this.isMobile && index !== 2) {
                // запускаем анимацию круга, убираем видимость слайдов
                this.rotateIndex = index;

                // после того, как слайды стали невидимыми, изменяем порядок слайдов
                setTimeout(() => {
                    if (index === 0) {
                        this.dataSlider.unshift(this.dataSlider.pop());
                        this.dataSlider.unshift(this.dataSlider.pop());
                    }
                    else if (index === 1) {
                        this.dataSlider.unshift(this.dataSlider.pop());
                    }
                    else if (index === 3) {
                        this.dataSlider.push(this.dataSlider.shift());
                    }
                    else if (index === 4) {
                        this.dataSlider.push(this.dataSlider.shift());
                        this.dataSlider.push(this.dataSlider.shift());
                    }
                }, 350);

                // возвращаем видимость слайдов
                setTimeout(() => {
                    this.rotateIndex = -1;
                }, 1100)
            }
        },
        changeScroll() {
            this.scrollTags = this.$refs.tags.scrollLeft;
            this.max = this.$refs.tags.scrollWidth - this.$refs.tags.clientWidth;
        },
        scrollToLeft() {
            this.$refs.tags.scrollTo({
                left: this.$refs.tags.scrollLeft - 160,
                behavior: "smooth"
            });
        },
        scrollToRight() {
            this.$refs.tags.scrollTo({
                left: this.$refs.tags.scrollLeft + 160,
                behavior: "smooth"
            });
        },
        openReview(id) {
            if (id) {
                this.$router.push({name: 'reviews', query: {idReview: id}});
            } else {
                this.$router.push({name: 'reviews', query: {form: 'true'}});
            }
        }
    },
    mounted() {
        setTimeout(() => {
            let dataSlider = this.$refs.aboutSlider.dataset.slider;
            dataSlider = dataSlider.replace(/'/g, '"');
            this.dataSlider = JSON.parse(dataSlider);

            this.max = this.$refs.tags.scrollWidth - this.$refs.tags.clientWidth;
            window.addEventListener('resize', this.changeScroll);
        }, 100)
    },
    ...routerPageHook,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.changeScroll);
    }
};


// WEBPACK FOOTER //
// ./src/templates/pages/about/index.js